(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-list"] && !Shopify.designMode) return;
  try {
    (() => {
    // Carosello delle card del megamenu: le frecce scorrono di una card e si
    // nascondono quando si e' arrivati in fondo.
    const lista = (el) => el.closest('.mega-menu__carousel')?.querySelector('.mega-menu__content-list--collections');

    const aggiorna = (ul) => {
      const box = ul.closest('.mega-menu__carousel');
      const max = ul.scrollWidth - ul.clientWidth - 2;
      box.querySelector('.mega-menu__carousel-arrow--prev').disabled = ul.scrollLeft <= 2;
      box.querySelector('.mega-menu__carousel-arrow--next').disabled = ul.scrollLeft >= max;
    };

    document.addEventListener('click', (event) => {
      const freccia = event.target.closest('.mega-menu__carousel-arrow');
      if (!freccia) return;
      event.preventDefault();
      const ul = lista(freccia);
      const card = ul.querySelector('li');
      const passo = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(ul).columnGap || 0) : ul.clientWidth;
      const verso = freccia.classList.contains('mega-menu__carousel-arrow--prev') ? -1 : 1;
      ul.scrollBy({ left: verso * passo });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        if (event.target instanceof Element && event.target.matches('.mega-menu__carousel--scroll .mega-menu__content-list--collections')) {
          aggiorna(event.target);
        }
      },
      true
    );

    // quando si apre una voce il carosello riparte dall'inizio, frecce comprese
    document.addEventListener(
      'mouseover',
      (event) => {
        const voce = event.target.closest?.('.mega-menu__link--parent[data-level2-index]');
        if (!voce) return;
        requestAnimationFrame(() => {
          voce.closest('.mega-menu__grid')
            ?.querySelectorAll('.mega-menu__carousel--scroll .mega-menu__content-list--collections')
            .forEach(aggiorna);
        });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
